import { z } from "zod";

export const AffiliationSchema = z.object({
  sku: z.string(),
  item_list_item_index: z.number().optional(),
  item_list_id: z.string().optional(),
  item_list_name: z.string().optional(),
  creative_name: z.string().optional(),
  creative_slot: z.string().optional(),
  promotion_id: z.string().optional(),
  promotion_name: z.string().optional(),
});

export type Affiliation = z.infer<typeof AffiliationSchema>;
